export const KEEP_OPEN_ATTRIBUTE = "data-reward-center-keep-open";

export const CMS_BRAND_SLUG = "bitcasino"; // TODO: Remove once IP-1883 is merged
